const genChartYAxisTicks = (isPlaceholder, maxReferrals?: number) => {
    if (isPlaceholder || !maxReferrals) {
        return [0, 2500, 5000, 7500, 10000, 12500, 15000, 17500, 20000];
    }

    const yAxisTicks = [0];
    const maxNo = Math.ceil((maxReferrals * 1.25) / 100) * 100;
    const baseNo = maxNo / 10;
    for (let x = 1; x <= 9; x++) {
        yAxisTicks.push(Math.floor(baseNo * x));
    }
    yAxisTicks.push(Math.floor(maxNo));
    return yAxisTicks;
};

export default genChartYAxisTicks;
